(function () {
  var mediaQuery = window.matchMedia('(min-width: 1024px)');
  var entry = null;
  var banner = null;
  var sidebarMount = null;
  var sidebarEntry = null;
  var sidebarVisible = false;
  var ticking = false;

  function queryElements() {
    entry = document.querySelector('[data-collection-entry-original]');
    banner = entry ? entry.closest('.collection-banner--hero') : null;
    sidebarMount = document.querySelector('[data-collection-entry-sidebar-mount]');
  }

  function createSidebarEntry() {
    if (!entry) return null;

    sidebarEntry = document.createElement('div');
    sidebarEntry.className = entry.className;
    sidebarEntry.innerHTML = entry.innerHTML;
    sidebarEntry.classList.add('collection-banner__entry--sidebar');
    return sidebarEntry;
  }

  function showSidebar() {
    if (!entry) return;
    if (!sidebarMount || !sidebarMount.isConnected) {
      sidebarMount = document.querySelector('[data-collection-entry-sidebar-mount]');
    }
    if (!sidebarMount) return;

    if (!sidebarEntry || !sidebarEntry.isConnected) {
      createSidebarEntry();
    }
    if (sidebarEntry && sidebarEntry.parentNode !== sidebarMount) {
      sidebarMount.appendChild(sidebarEntry);
    }
    sidebarMount.classList.add('is-active');
    sidebarVisible = true;
  }

  function hideSidebar() {
    if (sidebarEntry && sidebarEntry.parentNode) {
      sidebarEntry.parentNode.removeChild(sidebarEntry);
    }
    if (sidebarMount) sidebarMount.classList.remove('is-active');
    sidebarVisible = false;
  }

  function updatePosition() {
    ticking = false;
    if (!entry || !banner || !sidebarMount || !sidebarMount.isConnected) {
      queryElements();
    }

    if (!entry || !banner || !sidebarMount || !mediaQuery.matches) {
      hideSidebar();
      return;
    }

    var bannerBottom = banner.getBoundingClientRect().bottom;
    if (bannerBottom <= 0) {
      if (!sidebarVisible) {
        showSidebar();
      }
    } else {
      hideSidebar();
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updatePosition);
  }

  function init() {
    queryElements();
    updatePosition();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', requestUpdate);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(requestUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
